import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames';
import { APIURL } from '../../config/config'
import axios from 'axios'
import IncomeExpenseItemList from "../IncomeExpenseItem/IncomeExpenseItemList";
import UnitsSetting from "./UnitsSetting";
import CarSellListPaySetting from "./CarSellListPaySetting";

class SettingIncomeExpense extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeTab: '1',
      user: {} ,
    }

    this.toggle = this.toggle.bind(this);

  }

  componentWillMount () {
    this.setState({
      user: JSON.parse(this.props.user)
    });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render () {

    return (
      <div className="col-md-12 mb-4">
        <Nav tabs>
          <NavItem>
            <NavLink
                className={classnames({ active: this.state.activeTab === '1' })}
                onClick={() => { this.toggle('1'); }}
            >
              <i className="icon-plus"/> &nbsp;เพิ่มรายการรับชำระ
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === '2' })}
              onClick={() => { this.toggle('2'); }}
            >
              <i className="icon-plus"/> &nbsp;เพิ่มหมวดรายรับ-ค่าใช้จ่าย
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
                className={classnames({ active: this.state.activeTab === '3' })}
                onClick={() => { this.toggle('3'); }}
            >
              <i className="icon-plus"/> &nbsp;เพิ่มหน่วยสินค้า
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-lg-12">
                <CarSellListPaySetting />
              </div>
            </div>
          </TabPane>

          <TabPane tabId="2">
            <div className="row">
              <div className="col-lg-12">
                  <IncomeExpenseItemList />
              </div>
            </div>
          </TabPane>

          <TabPane tabId="3">
            <div className="row">
              <div className="col-lg-12">
                <UnitsSetting />
              </div>
            </div>
          </TabPane>
        </TabContent>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

const styles = {
  button: {
    borderRadius:5,
    height: 36,
  },
  inputSearch: {
    borderRadius:5,
  }
}

export default connect(mapStateToProps)(SettingIncomeExpense)
